import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type PressLogosCtaProps = CtaShellProps

export function PressLogosCta(props: PressLogosCtaProps) {
  return <CtaShell {...props} layout="centered" socialProof={props.socialProof ?? { logos: [{ name: "Forbes" }, { name: "Fast Company" }, { name: "TechCrunch" }, { name: "Wired" }, { name: "Inc." }] }} />
}
